export const ru = {
    at: 'на',
    'at-percent': 'на {conversionInput} %',
    down: 'уменьшить',
    max: 'макс',
    min: 'мин',
    up: 'увеличить'
};
